'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitState = exports.actionReducer = exports.actionsFromObj = exports.buildActions = exports.addRouteAction = undefined;

var _stubTrue2 = require('lodash/fp/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _reduce2 = require('lodash/fp/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _rearg2 = require('lodash/fp/rearg');

var _rearg3 = _interopRequireDefault(_rearg2);

var _isPlainObject2 = require('lodash/fp/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isArray2 = require('lodash/fp/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _cond2 = require('lodash/fp/cond');

var _cond3 = _interopRequireDefault(_cond2);

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _capeLodash = require('cape-lodash');

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _actions = require('./actions');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addRouteAction = exports.addRouteAction = function addRouteAction() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var item = arguments[1];
  return state.concat((0, _actions.addRoute)(item));
};
var buildActions = exports.buildActions = (0, _capeLodash.condId)([(0, _rearg3.default)([1], _utils.isValidRouteObj), addRouteAction]);

var actionsFromObj = exports.actionsFromObj = (0, _reduce3.default)(buildActions, undefined);
var actionReducer = exports.actionReducer = (0, _reduce3.default)(_reducer2.default, undefined);

function createErr(item) {
  var errMsg = 'location-info getInitState() only accepts array or obj. Got ' + (typeof item === 'undefined' ? 'undefined' : _typeof(item));
  throw new Error(errMsg);
}

var getInitState = exports.getInitState = (0, _cond3.default)([[_isArray3.default, actionReducer], [_isPlainObject3.default, (0, _flow3.default)(actionsFromObj, actionReducer)], [_stubTrue3.default, createErr]]);


//////////////////
// WEBPACK FOOTER
// ./~/location-info/lib/initState.js
// module id = 923
// module chunks = 0